<template>
  <div>
    <div
      class="text-center"
      v-if="!dataLoaded"
    >
      <v-progress-circular
        class="mt-6"
        color="primary"
        :size="50"
        indeterminate
      />
    </div>

    <div
      class="mt-4"
      v-show="dataLoaded"
    >
      <TitleCard
        :is-show-mode="isShowMode"
        :is-process-mode="isProcessMode"
        :is-edit-mode="isEditMode"
        :disabled="invalid"
        :saveLoading="saveBtnLoading"
        :selected-item="prePrintParent"
        :is-no-changes="isNoChanges"
        @save="savePrePrint"
      />

      <v-row
        class="mb-0 mt-2"
        style="margin-right: -14px"
      >
        <v-col
          ref="workList"
          cols="12"
          class="pt-1 pb-2 pr-2 overflow-auto"
        >
          <WorkTitleCard :title="this.workTypeRusName(workTypeName.PrePrint)" />

          <AuthorsCard
            class="mt-4"
            title="Автор"
            :selected-item.sync="prePrintParent.commonWork.authors"
            :is-show-mode="isShowMode"
            @updateInvalid="updateAuthorsInvalid"
          />

          <PrePrintCard
            class="mt-4"
            title="Основная информация"
            :selected-item.sync="prePrintParent"
            :is-show-mode="isShowMode"
            @updateInvalid="updatePrePrintInvalid"
          />

          <CommentCard
            v-if="Boolean(prePrintParent.commonWork.comment)"
            class="mt-4"
            :comment="prePrintParent.commonWork.comment"
          />

          <CreatorCard :creator-name="prePrintParent.commonWork.creator.fullName" />
        </v-col>
      </v-row>
    </div>
  </div>
</template>

<script>
import { prePrintApi } from '@/api'
import { PrePrint } from '../../models'
import PrePrintCard from '../../components/Works/PrePrint/PrePrintCard'
import TitleCard from '@/components/Works/elements/TitleCard'
import AuthorsCard from '../../components/Works/elements/AuthorsCard'
import CommentCard from '@/components/Works/elements/CommentCard.vue'
import { mapActions, mapGetters } from 'vuex'
import { workListHeight } from '@/mixins/workListHeight'
import WorkTitleCard from '@/components/Works/elements/WorkTitleCard.vue'
import CreatorCard from '@/components/Works/elements/CreatorCard.vue'
import { dictionaryNames, workMode, workTypeName } from '@/scripts/consts'

export default {
  name: 'PrePrintPage',
  components: { CreatorCard, WorkTitleCard, CommentCard, AuthorsCard, TitleCard, PrePrintCard },

  metaInfo() {
    return {
      title: this && this.workTypeRusName(workTypeName.PrePrint)
    }
  },

  mixins: [workListHeight],

  created() {
    this.isShowMode = this.$route.params.mode === workMode.Show
    this.isProcessMode = this.$route.params.mode === workMode.Process
    this.isEditMode = this.$route.params.mode === workMode.Edit
    this.getData()
  },

  data: () => ({
    prePrintParent: new PrePrint(),
    dataLoaded: false,
    isShowMode: false,
    isEditMode: false,
    isProcessMode: false,
    authorsInvalid: false,
    prePrintInvalid: false,
    saveBtnLoading: false,
    isNoChanges: true
  }),

  computed: {
    workTypeName() {
      return workTypeName
    },
    ...mapGetters('workTypes', ['workTypeByName', 'workTypeRusName']),

    invalid() {
      return this.authorsInvalid || this.prePrintInvalid
    }
  },

  methods: {
    ...mapActions('dictionaries', ['getDictionaries']),
    ...mapActions('workTypes', ['getWorkTypes']),

    async getData() {
      if (!this.isShowMode) {
        await this.getDictionaries([
          dictionaryNames.Year,
          dictionaryNames.State,
          dictionaryNames.InteractionType,
          dictionaryNames.PublicationForm
        ])
      }
      await this.getWorkTypes()
      await this.getPrePrint()
      this.dataLoaded = true
      this.isNoChanges = true
    },

    async getPrePrint() {
      try {
        if (this.$route.params?.id !== '0') {
          const data = await prePrintApi.get(this.$route.params?.id)
          this.prePrintParent = new PrePrint(data)
        }
      } catch (e) {
        console.log(e)
        this.showErrorMessage(e, 'Не удалось получить данные по работе')
      }
    },

    async savePrePrint(isThrowError = false) {
      try {
        this.saveBtnLoading = true

        if (!this.prePrintParent.id)
          this.prePrintParent.commonWork.workType = this.workTypeByName(workTypeName.PrePrint)

        const body = this.prePrintParent.getForAPI()

        const data = this.prePrintParent.id ? await prePrintApi.update(body) : await prePrintApi.create(body)

        if (!this.prePrintParent.id) await this.$router.replace('/works/prePrint/edit/' + data.id)

        this.prePrintParent = new PrePrint(data)
        this.$toast.info('Работа успешно сохранена')
        queueMicrotask(() => (this.isNoChanges = true))
      } catch (e) {
        console.log(e)
        this.showErrorMessage(e, 'Ошибка сохранения работы')
        if (isThrowError) throw new Error('Ошибка сохранения')
      } finally {
        this.saveBtnLoading = false
      }
    },

    async updateAuthorsInvalid(val) {
      this.authorsInvalid = val
      this.isNoChanges = false
    },

    async updatePrePrintInvalid(val) {
      this.prePrintInvalid = val
      this.isNoChanges = false
    }
  },

  watch: {
    dataLoaded() {
      this.setWorkListHeight()
    }
  },

  provide: function () {
    return {
      saveWork: this.savePrePrint
    }
  }
}
</script>

<style scoped></style>
